relatorios.component('relatorios.relatoriosComponent', {
    templateUrl: 'relatorios/relatorios.html',
    controller: 'relatorios.relatoriosController'
});

relatorios.controller('relatorios.relatoriosController', ['$scope', 'coreLanguage', '$state', 'coreFb', '$filter', function($scope, $text, $state, $fb, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.indicadores = {
        qtdAlunos: 0,
        qtdAlunosUnicos: 0,
        mediaAssistida: 0
    };

    const _getDadosReport=()=>{
        $state.params.showGlobalLoading = true;

        $fb.functions.invoke('aulas_listProgressProduto').then(res=>{
            $ctrl.indicadores.qtdAlunos = res.alunos;
            $ctrl.indicadores.qtdAlunosUnicos = res.alunosUnicos;
            
            let removeMedia=0;
            res.produtos.forEach(item=>{
                $ctrl.tableObj.data.push(item);

                if(item.iniciaram > 0){
                    $ctrl.indicadores.mediaAssistida +=  item.mediaAssistida;
    
                    item.mediaAssistida = $filter('number')(item.mediaAssistida, 2);
                }else{
                    removeMedia++;
                }
            });
            
            $ctrl.indicadores.mediaAssistida = $filter('number')(($ctrl.indicadores.mediaAssistida / ($ctrl.tableObj.data.length - removeMedia)), 2);
            $state.params.showGlobalLoading = false;
        });
    };

    $ctrl.tableObj = {
        pageSize: 100,
        pageCount: 1,
        columns:[
            {title: '', key:'fotoUrl', type:'image', export:false},
            {title: 'PRODUTO', width:'25%', key:'nome', type:'text', export:true},
            {title: 'INICIARAM', key:'iniciaram', type:'number', export:true},
            {title: 'CONCLUÍRAM', key:'concluiram', type:'number', export:true},
            {title: 'AULAS ASSISTIDAS (MÉDIA)', key:'mediaAssistida', type:'text', export:true}
        ],
        data:[],
        actions:{
            enable: {delete:false, edit:false, view:false},
        },
        bulkActions:{
            enable: {delete:false}
        }
    };

    $ctrl.$onInit = () => {
        _getDadosReport();
    };
    
}]);